var map = {
	"./BatchFile.png": 6946,
	"./Bitmap.png": 5323,
	"./CD Drive.png": 7807,
	"./Certificate.png": 4877,
	"./Control Panel.png": 3645,
	"./DLL.png": 7172,
	"./DataLink.png": 5750,
	"./Dial-Up Networking.png": 9636,
	"./Drive.png": 5576,
	"./EXE.png": 3128,
	"./Email.png": 3296,
	"./Entire Internet.png": 3774,
	"./Favorites.png": 9211,
	"./File.png": 8244,
	"./Floppy.png": 3336,
	"./Folder.png": 3110,
	"./HistoryFolder.png": 7124,
	"./INI.png": 1986,
	"./InternetExplorer.png": 3400,
	"./Linux.png": 1274,
	"./MSDOS.png": 3286,
	"./Mplayer.png": 7210,
	"./MyBriefcase.png": 4390,
	"./MyComputer.png": 3831,
	"./MyDocuments.png": 8816,
	"./NetDrive.png": 2053,
	"./Netwatch.png": 3084,
	"./NetworkNeighborhood.png": 6386,
	"./Notepad.png": 4711,
	"./Packager.png": 8360,
	"./Printer.png": 6212,
	"./ProgMan.png": 7152,
	"./RecyclingBin.png": 9687,
	"./Scheduled Tasks.png": 3891,
	"./Script.png": 9503,
	"./SystemFile.png": 8207,
	"./TextFile.png": 2829,
	"./WavFile.png": 7212,
	"./Web Folders.png": 5649,
	"./WordPad.png": 9419,
	"./github.png": 979
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9249;